import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {COPILOT_PLAN_VALUES, ORG_STATUS_VALUES} from '@github-ui/swp-core/lib/utils/personalization'
import * as z from 'zod'
import {VendorPixelSchema} from './analytics/vendor-pixel'

export const PayloadSchema = z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: safeOptional(z.looseObject({})),
    userLoggedIn: z.boolean().optional(),
    userCopilotPlan: safeOptional(z.enum(COPILOT_PLAN_VALUES)),
    orgMembershipType: safeOptional(z.enum(ORG_STATUS_VALUES)),
    orgAdminType: safeOptional(z.enum(ORG_STATUS_VALUES)),
    octocaptchaHost: z.string().optional(),
    hasNtExperiences: z.boolean().optional(),
    vendorPixels: safeOptional(z.array(VendorPixelSchema)),
  }),
)

export type Payload = z.infer<typeof PayloadSchema>

export function toPayload(payload: unknown): Payload {
  return PayloadSchema.parse(payload)
}

export function isPayload(payload: unknown): payload is Payload {
  return PayloadSchema.safeParse(payload).success
}
